export default "__VITE_ASSET__CQmVt3Hf__"